<template>
    <client-page class="app--main">
        <!-- S: visual -->
        <div class="visual">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="swiper-slide__inner">
                            <div class="visual__con">
                                <div class="visual__inner">
                                    <div class="text-ani-wrap">
                                        <div class="text-ani">
                                            <h2>Oil & Gas</h2>
                                        </div>
                                    </div>
                                    <p>
                                        The KIE Systems brings rich experience and unique solution together <br class="d-none d-lg-block" />
                                        in the engineering and integration such as analytical instruments.
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide__bg swiper-slide__bg--1"></div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="swiper-slide__inner">
                            <div class="visual__con">
                                <div class="visual__inner">
                                    <div class="text-ani-wrap">
                                        <div class="text-ani">
                                            <h2>Petrochemical</h2>
                                        </div>
                                    </div>
                                    <p>
                                        The KIE Systems brings rich experience and unique solution together <br class="d-none d-lg-block" />
                                        in the engineering and integration such as analytical instruments.
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide__bg swiper-slide__bg--2"></div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="swiper-slide__inner">
                            <div class="visual__con">
                                <div class="visual__inner">
                                    <div class="text-ani-wrap">
                                        <div class="text-ani">
                                            <h2>Power Plant</h2>
                                        </div>
                                    </div>
                                    <p>
                                        The KIE Systems brings rich experience and unique solution together <br class="d-none d-lg-block" />
                                        in the engineering and integration such as analytical instruments.
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide__bg swiper-slide__bg--3"></div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="swiper-slide__inner">
                            <div class="visual__con">
                                <div class="visual__inner">
                                    <div class="text-ani-wrap">
                                        <div class="text-ani">
                                            <h2>Renewable Energy</h2>
                                        </div>
                                    </div>
                                    <p>
                                        The KIE Systems brings rich experience and unique solution together <br class="d-none d-lg-block" />
                                        in the engineering and integration such as analytical instruments.
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide__bg swiper-slide__bg--4"></div>
                        </div>
                    </div>
                </div>
                <div class="swiper-control">
                    <div class="swiper-slide__inner">
                        <div class="visual__con">
                            <div class="visual-button-group">
                                <v-btn icon outlined large color="rgba(255, 255, 255, 0.25)" class="visual-button visual-prev mr-6 mr-lg-10"><i class="icon icon-left-arrow"></i></v-btn>
                                <v-btn icon outlined large color="rgba(255, 255, 255, 0.25)" class="visual-button visual-next"><i class="icon icon-right-arrow"></i></v-btn>
                            </div>
                            <div class="visual-pagination text-right"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="count-wrap">
                <v-container>
                    <v-row no-gutters class="count-group">
                        <v-col cols="4" class="count d-flex flex-column align-center justify-center text-center">
                            <p class="font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32">
                                Since 2002
                            </p>
                            <h2 class="font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18">
                                <span class="countup">20</span>
                            </h2>
                            <p class="font-size-14 font-size-lg-18 line-height-1" style="color: rgba(255, 255, 255, 0.4)">
                                Years
                            </p>
                        </v-col>
                        <v-col cols="4" class="count d-flex flex-column align-center justify-center text-center">
                            <p class="font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32">
                                Engineer
                            </p>
                            <h2 class="font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"><span class="countup">30</span>+</h2>
                            <p class="font-size-14 font-size-lg-18 line-height-1" style="color: rgba(255, 255, 255, 0.4)">
                                People
                            </p>
                        </v-col>
                        <v-col cols="4" class="count d-flex flex-column align-center justify-center text-center">
                            <p class="font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32">
                                Project
                            </p>
                            <h2 class="font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"><span class="countup">1000</span>+</h2>
                            <p class="font-size-14 font-size-lg-18 line-height-1" style="color: rgba(255, 255, 255, 0.4)">
                                Times
                            </p>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>
        <!-- E: visual -->

        <section class="main-section main-section1">
            <v-container>
                <h3 class="main-tit dot-tit">
                    Overseas Owners
                </h3>
                <v-row>
                    <v-col v-for="oversea in overseas" :key="oversea._id" cols="6" sm="4" md="3" lg="2">
                        <div class="logo-thum-wrap">
                            <div class="logo-thum" :style="`background-image: url(${oversea.thumb});`"></div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="main-section main-section2">
            <v-container>
                <h3 class="main-tit dot-tit">
                    Domestic Business Owners
                </h3>
                <v-row>
                    <v-col v-for="domestic in domestics" :key="domestic._id" cols="6" sm="4" md="3" lg="2">
                        <div class="logo-thum-wrap">
                            <div class="logo-thum" :style="`background-image: url(${domestic.thumb});`"></div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="main-section main-section3">
            <v-container>
                <h3 class="main-tit dot-tit">
                    EPC
                </h3>
                <v-row>
                    <v-col v-for="epc in epcs" :key="epc._id" cols="6" sm="4" md="3" lg="2">
                        <div class="logo-thum-wrap">
                            <div class="logo-thum" :style="`background-image: url(${epc.thumb});`"></div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import api from "@/api";
import Swiper from "swiper/bundle";
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
// import BoardList from "@/components/client/en/board/board-list.vue";
import PopupLayer from "@/components/client/en/popup/popup-layer.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        PopupLayer,
        // BoardList,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,

        partners: [],
        overseas: null,
        domestics: null,
        epcs: null,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.getBoards();
            var bullet = ["Oil & Gas", "Petrochemical", "Power Plant", "Renewable Energy"];
            this.$nextTick(() => {
                this.swiper = new Swiper(".visual .swiper-container", {
                    effect: "fade",
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    pagination: {
                        el: ".visual-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<div class="' + className + '"><span>' + bullet[index] + "</span></div>";
                        },
                    },
                    navigation: {
                        nextEl: ".visual-next",
                        prevEl: ".visual-prev",
                    },
                });
            });

            // countup
            const animationDuration = 1400;
            const frameDuration = 1000 / 60;
            const totalFrames = Math.round(animationDuration / frameDuration);
            const easeOutQuad = (t) => t * (2 - t);

            const animateCountUp = (el) => {
                let frame = 0;
                const countTo = parseInt(el.innerHTML, 10);
                const counter = setInterval(() => {
                    frame++;
                    const progress = easeOutQuad(frame / totalFrames);
                    const currentCount = Math.round(countTo * progress).toLocaleString("ko-KR");

                    if (parseInt(el.innerHTML, 10) !== currentCount) {
                        el.innerHTML = currentCount;
                    }

                    if (frame === totalFrames) {
                        clearInterval(counter);
                    }
                }, frameDuration);
            };

            const countupEls = document.querySelectorAll(".countup");
            countupEls.forEach(animateCountUp);
        },
        async getBoards() {
            let { boards: overseas } = await api.v1.boards.gets({
                params: { code: "overseas" },
            });
            let { boards: domestics } = await api.v1.boards.gets({
                params: { code: "domestic" },
            });
            let { boards: epcs } = await api.v1.boards.gets({
                params: { code: "epc" },
            });
            this.overseas = overseas;
            this.domestics = domestics;
            this.epcs = epcs;
        },
    },
};
</script>

<style scoped>
.visual {
    position: relative;
}

.visual .swiper-container {
    width: 100%;
    height: calc(100vh - 60px);
}

.visual .swiper-wrapper,
.visual .swiper-slide {
    height: 100%;
}

.swiper-slide__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: #f7f7f7;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transform: scale(1.15);
}

.visual .swiper-slide.swiper-slide-active .swiper-slide__bg {
    animation: scale 4.5s ease-out forwards;
}

.swiper-slide__bg--1 {
    background-image: url(/images/main/v1.png);
}
.swiper-slide__bg--2 {
    background-image: url(/images/main/v2.png);
}
.swiper-slide__bg--3 {
    background-image: url(/images/main/v3.png);
}
.swiper-slide__bg--4 {
    background-image: url(/images/main/v4.png);
}

@keyframes scale {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.15);
    }
}

.visual .swiper-slide__inner {
    padding: 0 0 130px;
}

.visual__con {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(var(--container) + 12px * 2);
    padding: 0 12px;
    margin: auto;
    color: #fff;
}

.visual__con h2 {
    font-size: 3.6rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 8px;
}

.visual__con p {
    font-size: 1.4rem;
    line-height: 20px;
}

.swiper-control {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    transform: translate(0, 0);
    max-width: unset;
    padding: 0;
}

.swiper-control .visual__con {
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.visual-pagination.swiper-pagination-bullets {
    display: none;
}

.visual-button-group {
    display: flex;
    align-items: flex-end;
    margin-bottom: 30px;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .visual__con h2 {
        font-size: 5rem;
        margin-bottom: 20px;
    }
}
@media (min-width: 1024px) {
    .visual-button:hover {
        background-color: rgba(255, 255, 255, 0.08) !important;
    }
    .visual-pagination.swiper-pagination-bullets {
        height: 100%;
        border-right: 1px solid rgba(255, 255, 255, 0.25);
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .visual .swiper-slide__inner {
        padding: 0 0 300px;
    }
    .visual__con h2 {
        font-size: 7.2rem;
        margin-bottom: 30px;
    }

    .visual__con p {
        margin-bottom: 90px;
        font-size: 1.8rem;
        line-height: 28px;
    }
    .swiper-control .visual__con {
        align-items: center;
        justify-content: flex-end;
    }
    .visual-button-group {
        height: 276px;
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        margin-bottom: 0;
    }
}
@media (min-width: 1200px) {
    .visual .swiper-container {
        height: 100vh;
    }
    .visual .swiper-slide__inner {
        padding: var(--header-body) 0 300px;
    }
}

.count-wrap {
    border-top: 1px solid rgba(255, 255, 255, 0.25);
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 5;
}
.count {
    height: 130px;
    border-right: 1px solid rgba(255, 255, 255, 0.25);
}
.count-group .count:not(:last-child) {
    border-left: 1px solid rgba(255, 255, 255, 0.25);
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .count {
        height: 300px;
    }
}
@media (min-width: 1200px) {
}
</style>
